import { Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { StateService } from '@uirouter/angular';
import { JobService } from 'src/app/core/services/job.service';
import { NotificationsService } from 'src/app/core/services/notifications.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { UserNotificationsActionsModalComponent } from './user-notifications-actions-modal/user-notifications-actions-modal.component';
import { CompanyService } from 'src/app/core/services/company.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { RequisitionService } from 'src/app/core/services/requisition.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { DebounceService } from 'src/app/core/services/debounce.service';
import { DateTimeUtilityService } from 'src/app/core/services/date-time-utility.service';
import { OutreachService } from 'src/app/core/services/outreach.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { DisplayOnMultiSelectPipe } from 'src/app/core/pipes/display-on-multi-select.pipe';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { WebSocketsService } from 'src/app/core/services/web-sockets.service';
import { SharedAjsService } from 'src/app/core/services/shared-ajs.service';
import { ViewAssessmentReportModalComponent } from 'src/app/shared/job-match-actions/view-assessment-report/view-assessment-report-modal.component';
import * as _ from 'lodash';

declare var moment: any;
declare var scrollIntoView: any;
declare var $: any;

@Component({
  selector: 'app-user-notifications, user-notifications',
  templateUrl: './user-notifications.component.html',
  styleUrls: ['./user-notifications.component.css']
})
export class UserNotificationsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() height: any;
  @Input() width: any;
  @Input() numberOfNewNotifications: any;
  @Output() numberOfNewNotificationsChange = new EventEmitter<any>();
  @Input() searchObject: any;
  @Input() viewAllFlag: any;
  @Input() viewAllMode: any;
  @Input() context: any;
  @Input() userNotificationControls: any;
  @Output() userNotificationControlsChange = new EventEmitter<any>();
  @Input() showFilters: any;
  @Input() showShortNotification: any;
  @Output() showShortNotificationChange = new EventEmitter<any>();
  @Input() notificationClicked: any;
  @Input() fullView: any;
  @Output() closeCallback = new EventEmitter<void>();
  @Input() jobTypeList: any;
  @Input() salaryDurationOptions: any;

  MESSAGECONSTANTS: any = MESSAGECONSTANTS;

  // flags
  showShortMessagesFlag = true;
  isStaffingCompany: any;
  // variables
  userId: any;
  companyId: any;
  searchObjectStartDate: any = null;
  searchObjectEndDate: any = null;
  // objects
  filterObject: any = {};
  fullClientsList: any[] = [];
  fullClientsListCopy: any[];
  selectedClients: any[] = [];
  fullRolesList: any[] = [];
  fullRolesListCopy: any[];
  selectedRoles: any[] = [];
  fullReqNumList: any[] = [];
  fullReqNumListCopy: any[];
  selectedRequisitionNumbers: any[] = [];
  notificationsContainer: NotificationsContainer;
  loadingClientsOrBUs: boolean;
  loadingRoles: boolean;
  loadingRequisitionNumbers: boolean;
  loadingNotificationTypes: boolean;
  alertTypes: any;
  searchReqText: any;

  private _searchNotificationsDebounced: any;
  private notificationReceiveSubscription!: Subscription;

  constructor(
    private $state: StateService,
    @Inject(WebSocketsService) private webSocketsService: WebSocketsService,
    @Inject(SharedAjsService) private sharedAjsService: SharedAjsService,
    @Inject(StorageService) private StorageService: StorageService,
    private authService: AuthService,
    private jobMatchService: JobMatchService,
    private displayOnMultiSelectPipe: DisplayOnMultiSelectPipe,
    private planService: PlanService,
    private companyService: CompanyService,
    private requisitionService: RequisitionService,
    private jobService: JobService,
    private userRoleService: UserRoleService,
    private utilityService: UtilityService,
    private debounceService: DebounceService,
    private dateTimeUtilityService: DateTimeUtilityService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private notificationsService: NotificationsService,
    private modalService: AngularModalService,
    private outreachService: OutreachService,
    private candidateService: CandidateService,
    private bsModalService: BsModalService
  ) {
    this._searchNotificationsDebounced = _.debounce(() => this._searchNotifications(), 500);
  }

  ngOnInit() {
    // flags
    this.showShortMessagesFlag = true;
    this.isStaffingCompany = this.companyService.isStaffingCompany();
    // variables
    this.userId = this.authService.getUserDetails().id;
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.searchObjectStartDate = null;
    this.searchObjectEndDate = null;

    // objects
    this.filterObject = {};
    this.fullClientsList = [];
    this.selectedClients = [];
    this.fullRolesList = [];
    this.selectedRoles = [];
    this.fullReqNumList = [];
    this.selectedRequisitionNumbers = [];

    if (_.isUndefined(this.height)) {
      this.height = '400px';
    }
    if (_.isUndefined(this.width)) {
      this.width = '100%';
    }
    if (_.isUndefined(this.viewAllFlag)) {
      this.viewAllFlag = false;
    }
    if (_.isUndefined(this.viewAllMode)) {
      this.viewAllMode = 'modal';
    }
    if (_.isUndefined(this.context)) {
      this.context = 'global';
    }
    if (_.isUndefined(this.userNotificationControls)) {
      this.userNotificationControls = {};
    }
    if (_.isUndefined(this.numberOfNewNotifications)) {
      this.numberOfNewNotifications = 0;
    }
    if (_.isUndefined(this.showFilters)) {
      this.showFilters = false;
    }
    if (this.showFilters) {
      this._initializeDateAndTimePickersForFilters();
      this.getNotificationTypes();
      if (this.context == 'global') {
        this._getFilters();
      }
      // do not show short messages because this is the full notifications view.
      this.showShortMessagesFlag = false;
    }
    this.notificationsContainer = new NotificationsContainer(this.authService, this.context, this.showShortNotification, this.searchObject, this.showFilters, this.fullView, this.alertsAndNotificationsService, this.notificationsService, this.isStaffingCompany, this.outreachService);
    this.userNotificationControls.setNewNotificationsAsViewed = this.notificationsContainer.setNewNotificationsAsViewed();
    this.userNotificationControlsChange.emit(this.userNotificationControls);
    this.filterObject.text = '';
    this._initializeNotificationReceive();
    this._setSearchEvents();
    this.searchNotifications();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.userNotificationControls && this.userNotificationControls.notificationClickCount > 0 && this.notificationsContainer) {
      this.notificationsContainer.isNotificationIconClicked = true;
      // enable infinite scrolling if icon is clicked and notifications exist
      if (this.notificationsContainer.notificationsExistFlag) {
        this.notificationsContainer.disableInfiniteScroll = false;
      }
      this.notificationsContainer.setNewNotificationsAsViewed();
    }
    if (this.userNotificationControls) {
      this.userNotificationControls.notificationClickCount = (this.userNotificationControls.notificationClickCount || 0) + 1;
      this.userNotificationControlsChange.emit(this.userNotificationControls);
    }
  }

  _getFilters() {
    this.getNotificationTypes();
    this._getClientsOrBus(() => {
      this._getRoles('all');
      this.getRequisitionNumbers('all');
    });
  }

  _setSearchEvents() {
    $(document).ready(() => {
      $('#user-notifications-search-panel').hide();
      $(document).off('click', '#user-notifications-open-filter').on('click', '#user-notifications-open-filter',
        () => {
          $('#user-notifications-search-panel').animate({
            height: 'toggle'
          });
        }
      );
    });
  }

  resetSearchFilters() {
    this.notificationsContainer.searchObject = new SearchObject(this.authService.getUserDetails().company.companyId, this.showFilters);
    this.searchObjectStartDate = '';
    this.searchObjectEndDate = '';
    this.searchNotifications();
  }

  searchNotifications() {
    this._searchNotificationsDebounced();
  }

  _searchNotifications() {
    // Check if there's already a request in progress
    if (this.notificationsContainer.busy) {
      return;
    }

    this.notificationsContainer.searchObject.page = '';
    this.notificationsContainer.currentPromise = null;
    this.notificationsContainer.disableInfiniteScroll = false;
    this.notificationsContainer.notificationsExistFlag = true;
    this.notificationsContainer.notifications = [];
    this.notificationsContainer.newNotifications = [];
    this.notificationsContainer.searchObject.clientOrBuIds = this.selectedClients.map(clientOrBu => clientOrBu.id);
    this.notificationsContainer.searchObject.roleNames = this.selectedRoles.map(role => role.name);
    this.notificationsContainer.searchObject.reqNumbers = this.selectedRequisitionNumbers.map(req => req.name);
    this.notificationsContainer.notificationCalledOnce = 0;
    this.notificationsContainer.getNext(this);

    // Wait until first getNext() finishes (busy = false)
    const trySecondLoad = () => {
      if (!this.notificationsContainer.busy) {
        if (this.notificationsContainer.notificationCalledOnce <= 1 &&
          this.notificationsContainer.originalNotificationCount > this.notificationsContainer.filteredNotificationCount) {
          this.notificationsContainer.getNext(this);
        }
      } else {
        setTimeout(trySecondLoad, 100);
      }
    };

    setTimeout(trySecondLoad, 100);
  }

  _initializeNotificationReceive() {
    this.notificationReceiveSubscription = this.webSocketsService.receive().subscribe((message) => {
      let performChangeFlag = false;
      // Bulk upload progress/completion frames are handled by the bulk upload snackbar. Update frames
      // (e.g. NEW -> READ) still carry a stored notification, so let them reach the state handling below.
      if (message.eventType === 'BULK_UPLOAD_PROGRESS' ||
        (message.eventType === 'BULK_UPLOAD_COMPLETED' && message.operation !== 'update')) { return; }
      // Do not show banner message under notifications
      if (message.notifyOn.indexOf('BANNER') != -1) {
        if (message.eventType === 'PLAN_EXPIRATION_WARNING' || message.eventType === 'CURRENT_PLAN_ACTIVATED') {
          this._savePlanDetails();
        } else {
          this._setCompanyState(message.text);
        }
      } else if (message.notifyOn.indexOf('SNACK_BAR') != -1 && message.eventType === 'ASSESSMENTS_SYNC') {
        this._displayAssessmentsSyncMessage(message.taggedText);
      } else {
        if (this.context == 'global') {
          if (message.notifyOn.indexOf('NO_GLOBAL') == -1) {
            performChangeFlag = true;
          }
        } else if (this.context == 'candidateCard') {
          if (!_.isNull(message.candidateId) && (message.notifyOn.indexOf('CANDIDATE_CARD') != -1) && (message.candidateId == this.notificationsContainer.searchObject.candidateId)) {
            performChangeFlag = true;
          }
        } else if (this.context == 'candidateJobMatchCard') {
          if (!_.isNull(message.jobMatchId) && (message.notifyOn.indexOf('CANDIDATE_JOB_CARD') != -1) && (message.jobMatchId == this.notificationsContainer.searchObject.jobMatchId)) {
            performChangeFlag = true;
          }
        } else if (this.context == 'requisitionCard') {
          if (!_.isNull(message.jobId) && (message.notifyOn.indexOf('REQUISITION_CARD') != -1) && (message.jobId == this.notificationsContainer.searchObject.jobId)) {
            performChangeFlag = true;
          }
        }
        if (performChangeFlag) {
          message = this.notificationsContainer.massageMessageData(message);
          if (message.operation == 'update' && message.outreachSent === true) {
            const sentNotification = _.find(this.notificationsContainer.notifications, {
              notificationId: message.notificationId
            });
            if (sentNotification) {
              sentNotification.outreachSent = true;
            }
          }
          if (message.operation == 'new') {
            let index = _.findIndex(this.notificationsContainer.notifications, {
              notificationId: message.notificationId
            });
            if (index == -1) {
              this.notificationsContainer.newNotifications.unshift(message);
              this.numberOfNewNotifications = this.numberOfNewNotifications + 1;
              this.numberOfNewNotificationsChange.emit(this.numberOfNewNotifications);
              this.notificationsContainer.notifications.unshift(message);
              this.notificationsContainer.notificationsExistFlag = true;
              // Update Notification
              this.updateNotification(index, message);
            }
            if (message.notifyOn.indexOf('JOB_BOARD_SEARCH_FAILED') != -1) {
              let title = 'Alert!';
              let alertMessage = `We have reached the limit for the number of resume pulls from <b>${message.jobBoardName}</b>. Please talk to your administrator if you need to increase the resume pull limits for that specific Job Board.`;
              this.alertsAndNotificationsService.showAlert(title, alertMessage, 'warning');
            }
          } else if (message.operation == 'update' && message.state == 'READ') {
            let index = _.findIndex(this.notificationsContainer.notifications, {
              notificationId: message.notificationId
            });
            if (index !== -1) {
              this.notificationsContainer.notifications[index].state = message.state;
              this.updateNotification(index, message);
              let removedArray = _.remove(this.notificationsContainer.newNotifications, {
                notificationId: message.notificationId
              });
              if (removedArray.length > 0) {
                this.numberOfNewNotifications = this.numberOfNewNotifications - 1;
                this.numberOfNewNotificationsChange.emit(this.numberOfNewNotifications);
              }
            } else if (this.context == 'global') {
              this.numberOfNewNotifications = this.numberOfNewNotifications - 1;
              this.numberOfNewNotificationsChange.emit(this.numberOfNewNotifications);
            }
          }
        }
      }
    });
  }

  updateNotification(index, message) {
    if (message && message.eventType && message.eventType === 'JOB_BOARD_SEARCH_COMPLETED') {
      if (this.notificationsContainer && this.notificationsContainer.notifications && this.notificationsContainer.notifications[index]) {
        if (this.notificationsContainer.notifications[index].notificationId === message.notificationId) {
          this.notificationsContainer.notifications[index].candidateDtoMap = message.candidateDtoMap ? message.candidateDtoMap : this.notificationsContainer.notifications[index].candidateDtoMap;
        }
      }
    }
  }

  _savePlanDetails() {
    this.planService.getCurrentPlan(this.authService.getUserDetails().company.companyId, (data) => {
      this.authService.userDetails.plan.planName = data.planHeaderDto.planName;
      this.authService.userDetails.plan.startDate = moment(data.planHeaderDto.planStartDate);
      this.authService.userDetails.plan.endDate = moment(data.planHeaderDto.planEndDate);
      this.authService.userDetails.plan.planType = data.planHeaderDto.planType;
      this.authService.userDetails.plan.message = this.planService.getPlanExpiryMessage(this.authService.userDetails.plan.planType, this.authService.userDetails.plan.endDate, true);
      this.authService.notifyUserDetailsChanged();
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _setCompanyState(text) {
    let index = text.substring(0, text.length - 3).lastIndexOf('\'') + 1;
    let lastIndex = text.lastIndexOf('\'');
    let companyState = text.substring(index, lastIndex);
    console.log(companyState);
    this.authService.userDetails.company.companyState = companyState;
    this.companyService.setCompanyStateLabel();
    if (companyState == 'Hold' && !this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin()) {
      this.authService.requestLogout({ logoutnow: true });
    }
    this.StorageService.set('userDetails', _.cloneDeep(this.authService.userDetails), {
      'expires': new Date(Date.now() + this.authService.tokenvalidity)
    });
  }

  _displayAssessmentsSyncMessage(taggedHtmlText) {
    this.sharedAjsService.displayAssessmentsSyncMessage(this._getHighlightedNotificationHTML(taggedHtmlText));
  }

  onNotificationClicked($event, notification, notificationIndex) {
    if (this.showShortNotification) {
      this.expandNotification($event, notification, notificationIndex);
    }
    this.markNotificationAsRead($event, notification);
  }

  _showAssessmentReport(jobMatchId, assessmentType, testInvitationId) {
    const config = new ModalConfig();
    config.class = 'custom-modal-xl custom-candidate-job-match-modal';
    config.initialState = {
      jobMatchId,
      assessmentType,
      testInvitationId,
      context: 'notification'
    };
    this.bsModalService.show(ViewAssessmentReportModalComponent, config);
  }

  markNotificationAsRead($event, notification) {
    $event.stopPropagation();
    if (notification.state == 'NEW' || notification.state == 'VIEWED') {
      let stateObject = {
        notificationIds: [],
        state: 'READ'
      };
      stateObject.notificationIds.push(notification.notificationId);
      this.notificationsService.setNotificationsState(stateObject, (data) => {
        // do nothing. notification state change will be received as a push update.
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }
  }

  performAction(actionType) {
    let selectedUserNotifications = [];
    this.notificationsContainer.notifications.forEach((val) => {
      if (val.selectedFlag) {
        selectedUserNotifications.push(val);
      }
    });
    if (selectedUserNotifications.length == 0) {
      this.alertsAndNotificationsService.showAlert('No Notifications Selected!', 'Please select at least one notification to perform this action.', 'warning');
    } else {
      switch (actionType) {
        case 'markAsRead':
          let stateObject = {
            notificationIds: [],
            state: 'READ'
          };
          if (this.notificationsContainer.selectAll) {
            let markAsReadFilter = _.cloneDeep(this.notificationsContainer.searchObject);
            markAsReadFilter.excludedNotificationIds = this.notificationsContainer.notifications
              .filter(notification => notification.selectedFlag == false)
              .map(notification => notification.notificationId);
            this.notificationsService.changeStateForNotificationsByFilter('READ', markAsReadFilter, (data) => {
              selectedUserNotifications.forEach((val) => {
                val.selectedFlag = this.notificationsContainer.selectAll;
              });
            }, (error) => {
              this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
          } else {
            selectedUserNotifications.forEach((val) => {
              stateObject.notificationIds.push(val.notificationId);
            });
            this.notificationsService.setNotificationsState(stateObject, (data) => {
              selectedUserNotifications.forEach((val) => {
                val.selectedFlag = this.notificationsContainer.selectAll;
              });
            }, (error) => {
              this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
          }
          break;
        default:
        // do nothing
      }
    }
  }

  onStartDateFilterChange(value: string) {
    if (!value) {
      this.notificationsContainer.searchObject.startDateTime = null;
      this.searchNotifications();
    }
  }

  onEndDateFilterChange(value: string) {
    if (!value) {
      this.notificationsContainer.searchObject.endDateTime = null;
      this.searchNotifications();
    }
  }

  _initializeDateAndTimePickersForFilters() {
    $(document).ready(() => {
      let currentDate = new Date();

      $('#userNotificationsStartDate').datepicker({
        format: 'M d, yyyy',
        endDate: currentDate,
        weekStart: 1,
        autoclose: true
      });

      $('#userNotificationsEndDate').datepicker({
        format: 'M d, yyyy',
        endDate: currentDate,
        weekStart: 1,
        autoclose: true
      });

      $('#userNotificationsStartDate').datepicker().on('changeDate', (e) => {
        // bootstrap-datepicker sets the input's value via jQuery and only fires a
        // native 'change' event; Angular's ngModel (unlike AngularJS's) only listens
        // for 'input', so searchObjectStartDate never syncs from a calendar pick
        // without this explicit read from the DOM value.
        this.searchObjectStartDate = $(e.target).val() as string;
        this._validateAndCorrectStartDateAndEndDate();
        let startDate = new Date(this.searchObjectStartDate);
        this.notificationsContainer.searchObject.startDateTime = isNaN(startDate.getTime()) ? null : this.dateTimeUtilityService.getDateTimeInAPIFormat(startDate);
        this.searchNotifications();
      });

      $('#userNotificationsEndDate').datepicker().on('changeDate', (e) => {
        this.searchObjectEndDate = $(e.target).val() as string;
        this._validateAndCorrectStartDateAndEndDate();
        let endDate = new Date(this.searchObjectEndDate + ' 11:59:59 PM');
        this.notificationsContainer.searchObject.endDateTime = isNaN(endDate.getTime()) ? null : this.dateTimeUtilityService.getDateTimeInAPIFormat(endDate);
        this.searchNotifications();
      });
    });
  }

  _validateAndCorrectStartDateAndEndDate() {
    if (!_.isNull(this.searchObjectStartDate) && this.searchObjectStartDate != '' && !_.isNull(this.searchObjectEndDate) && this.searchObjectEndDate != '') {
      let momentOfCurrentStartDate = moment(new Date(this.searchObjectStartDate));
      let momentOfCurrentEndDate = moment(new Date(this.searchObjectEndDate));
      if (momentOfCurrentEndDate.isBefore(momentOfCurrentStartDate, 'day')) {
        let defaultEndDate = momentOfCurrentStartDate.add(1, 'd').toDate();
        $('#userNotificationsEndDate').datepicker('setDate', defaultEndDate);
      }
    }
  }

  viewAllNotifications() {
    if (this.viewAllMode == 'navigate') {
      this.$state.go('missioncontrol.notifications', { searchObject: this.notificationsContainer.searchObject, context: this.context }, { reload: true });
    } else if (this.viewAllMode == 'modal') {
      let searchObj = _.cloneDeep(this.notificationsContainer.searchObject);
      searchObj.size = 6;
      const config = new ModalConfig();
      config.class = 'custom-modal-xl custom-candidate-job-match-modal';
      config.ignoreBackdropClick = true;
      config.keyboard = false;
      config.initialState = {
        actionType: 'viewAllNotifications',
        actionLabel: 'View All Notifications',
        searchObject: searchObj,
        context: this.context,
        jobTypeList: this.jobTypeList,
        salaryDurationOptions: this.salaryDurationOptions
      };
      this.bsModalService.show(UserNotificationsActionsModalComponent, config as ModalOptions);
    }
  }

  selectAllNotifications() {
    this.notificationsContainer.notifications.forEach((notification) => {
      notification.selectedFlag = this.notificationsContainer.selectAll;
    });
  }

  onNotificationSelectionChange(selectedFlag) {
    // no-op, matches original AJS controller.
  }

  expandNotification($event, notification, notificationIndex) {
    notification.showShortMessageFlag = !notification.showShortMessageFlag;
    $event.stopPropagation();
    if (!notification.showShortMessageFlag) {
      setTimeout(() => {
        scrollIntoView(document.getElementById(notification.notificationId + '-' + notificationIndex), { behavior: 'smooth', block: 'end', scrollMode: 'if-needed' });
      }, 200);
    }
  }

  _goToCandidateDocuments(notification) {
    let actionType = 'candidateBooklet';
    let actionLabel = notification.documentDtoMap.fullName + '\'s' + ' Booklet';
    notification.documentDtoMap.isNotification = true;
    if (notification.documentDtoMap.eventType && notification.documentDtoMap.eventType == 'DOCUMENT_EMAIL_NOTIFICATION') {
      actionType = 'emailNotification';
      actionLabel = 'Details of Documents Emailed';
    }
    this.sharedAjsService.goToCandidateDocuments(actionType, actionLabel, notification.documentDtoMap);
  }

  goToResumeProcessedCandidates(notification) {
    const config = new ModalConfig();
    config.class = 'custom-modal-xl custom-candidate-job-match-modal';
    config.ignoreBackdropClick = true;
    config.keyboard = false;
    config.initialState = {
      actionType: 'resumeProcessedCandidates',
      actionLabel: 'Resume Processed Candidates',
      candidatesCount: notification.candidateDtoMap,
      jobId: notification.jobId,
      candidateId: notification.candidateId,
      notificationId: notification.notificationId,
      // Shared by reference so the modal can flag the notification as outreach sent in the list.
      notification,
      headingTitle: notification.highlightedHTMLText
    };
    this.bsModalService.show(UserNotificationsActionsModalComponent, config as ModalOptions);
  }

  _showBulkUploadDetails(notification) {
    const config = new ModalConfig();
    config.class = 'custom-modal-xl custom-candidate-job-match-modal';
    config.ignoreBackdropClick = true;
    config.keyboard = false;
    config.initialState = {
      actionType: 'bulkUploadDetails',
      actionLabel: 'Bulk Upload Details',
      jobId: notification.jobId,
      candidateDtoMap: notification.candidateDtoMap,
      bulkUploadDate: moment(notification.createdDate).format('MMM DD, YYYY hh:mm A')
    };
    this.bsModalService.show(UserNotificationsActionsModalComponent, config as ModalOptions);
  }

  goToWorkflow($event, notification) {
    this.markNotificationAsRead($event, notification);

    // Display processed resumes
    if (notification.eventType == 'JOB_SCORE_SYNC_COMPLETED') {
      this.$state.go('missioncontrol.candidateJobMatchesWorkflow', {
        jobId: notification.candidateDtoMap.reqId,
        searchString: ''
      });
    }

    if (notification.eventType == 'RESUME_SCORE_SYNC_COMPLETED') {
      this.goToResumeProcessedCandidates(notification);
    }

    if (notification.eventType == 'BULK_UPLOAD_PROGRESS' || notification.eventType == 'BULK_UPLOAD_COMPLETED') {
      this._showBulkUploadDetails(notification);
    }

    if (notification.eventType == 'JOB_BOARD_SEARCH_COMPLETED' || (notification.jbiTransactionId && notification.jbiTransactionId)) {
      let actionType = 'reviewJobPull';
      let actionLabel = 'Review Job Board Pull';
      let closeCallback = null;
      switch (actionType) {
        case 'reviewJobPull':
          closeCallback = () => {
            if ((this.$state.current.name == 'missioncontrol.candidateJobMatchesWorkflow') && (notification.jobId == this.$state.params.jobId)) {
              this.jobMatchService.requestJobWorkflowRefresh();
            }
          };
          break;
        default:
          break;
      }
      const config = new ModalConfig();
      config.class = 'custom-modal-xl custom-candidate-job-match-modal';
      config.ignoreBackdropClick = true;
      config.keyboard = false;
      config.initialState = {
        jobId: notification.jobId,
        jbiTransactionId: notification.jbiTransactionId,
        notificationHTMLText: notification.highlightedHTMLText,
        actionType: actionType,
        actionLabel: actionLabel,
        closeCallback: closeCallback,
        candidateDtoMap: notification.candidateDtoMap,
        notificationId: notification.notificationId
      };
      this.bsModalService.show(UserNotificationsActionsModalComponent, config as ModalOptions);
    }
    // view Generated PDF
    if (!_.isUndefined(notification.assessmentType) && !_.isNull(notification.assessmentType)) {
      this._showAssessmentReport(notification.jobMatchId, notification.assessmentType, notification.testInvitationId);
    }

    if (!_.isNull(notification.redirect) && !notification.documentDtoMap) {
      this.$state.go('missioncontrol.candidateJobMatchesWorkflow', {
        jobId: notification.redirect.jobId,
        searchString: notification.redirect.candidateEmail
      });
    }

    if (!_.isNull(notification.requisitionScreenRedirect) && notification.eventType === 'CANDIDATE_JOB_MATCH_RE_RUN_SCORING') {
      this.$state.go('missioncontrol.candidateJobMatchesWorkflow', {
        jobId: notification.requisitionScreenRedirect.jobId,
        searchString: notification.requisitionScreenRedirect.candidateEmail
      });
    }

    if (!_.isNull(notification.requisitionScreenRedirect) && notification.eventType === 'REQUISITION_RE_RUN_SCORING') {
      this.$state.go('missioncontrol.candidateJobMatchesWorkflow', {
        jobId: notification.requisitionScreenRedirect.jobId,
        searchString: ''
      });
    }

    // Redirect to Candidate Documents Tab
    if (notification.documentDtoMap) {
      this._goToCandidateDocuments(notification);
    }

    if (this.closeCallback) {
      this.closeCallback.emit();
    }
  }

  goToCandidatesScreen($event, notification) {
    this.markNotificationAsRead($event, notification);
    let redirectInfo = notification.candidateScreenRedirect;
    if (redirectInfo) {
      let candidateType = redirectInfo.vendorCandidate ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
      this.$state.go('missioncontrol.candidates', {
        searchString: redirectInfo.candidateEmail,
        candidateType: candidateType
      });
    } else {
      this.$state.go('missioncontrol.candidates', null);
    }
    if (this.closeCallback) {
      this.closeCallback.emit();
    }
  }

  checkIfAllDisabled(jobMatches) {
    if (!jobMatches || jobMatches.length === 0) {
      return true;
    }
    return jobMatches.every(jm => jm.outreachDisabled === true);
  }

  openResultsModal(event, notification, notificationIndex) {
    let candidateId = notification.candidateId ? notification.candidateId : notification.candidateOutreachJobMatchesInfo.candidateId;
    let candidateName = (notification.candidateOutreachJobMatchesInfo && notification.candidateOutreachJobMatchesInfo.candidateName) ? notification.candidateOutreachJobMatchesInfo.candidateName : null;
    let actionLabel = notificationIndex === 'candidateNoLongerMatch' ? 'Reasons for Candidate Mismatch' : `Job Matches ${candidateName ? '\for <b>\'' + candidateName + '\'</b>' : ''}`;
    let actionType = notificationIndex === 'candidateNoLongerMatch' ? 'candidateNoLongerMatch' : 'outreachNoResponse';
    let windowClass = 'custom-modal-xl custom-candidate-job-match-modal';
    let isOutreachExpiryDataExists = notification.isOutreachExpiryDataExists;
    let allJobMatchesDisabled = this.checkIfAllDisabled(notification.candidateOutreachJobMatchesInfo ? notification.candidateOutreachJobMatchesInfo.jobMatches : null);
    let isSendOutreachAgainEnabled = notification.eventType.includes('REMINDER') || notification.eventType.includes('EXPIRY') || notification.eventType.includes('EXPIRED');
    const config = new ModalConfig();
    config.class = windowClass;
    config.ignoreBackdropClick = true;
    config.keyboard = false;
    config.initialState = {
      actionType: actionType,
      actionLabel: actionLabel,
      notification: notification,
      isStaffingCompany: this.isStaffingCompany,
      jobTypeList: this.jobTypeList,
      salaryDurationOptions: this.salaryDurationOptions,
      isOutreachExpiryDataExists: isOutreachExpiryDataExists,
      candidateId: candidateId,
      selectAllJobMatches: false,
      allJobMatchesDisabled: allJobMatchesDisabled,
      isSendOutreachAgainEnabled: isSendOutreachAgainEnabled
    };
    this.bsModalService.show(UserNotificationsActionsModalComponent, config as ModalOptions);
  }

  _getHighlightedNotificationHTML(text) {
    let newText = text.replace(/<4dot5>/g, '<span class=\'emerald\'>');
    return newText ? newText.replace(/<\/4dot5>/g, '</span>') : '';
  }

  _getClientsOrBus(successCallback?) {
    this.loadingClientsOrBUs = true;
    let requisitionId = null;
    let isFromCreateReq = false;
    this.requisitionService.getAllClientsOrBu(this.authService.getUserDetails(), requisitionId, isFromCreateReq, (data) => {
      this._setClientsOrBus(data);
      this.loadingClientsOrBUs = false;
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.loadingClientsOrBUs = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _setClientsOrBus(clientsOrBus) {
    this.fullClientsList = clientsOrBus;
    this.fullClientsList.forEach((clientOrBu) => {
      if (clientOrBu.companyType == 'Corporation') {
        clientOrBu.name = '<span style=\'padding-right:5px;\'>' + clientOrBu.name + '</span><i class=\'fas fa-share-alt\'></i>';
      }
    });
    this.fullClientsListCopy = _.cloneDeep(this.fullClientsList);
  }

  onClientClick() {
    this._getRoles('all', () => {
      this.getRequisitionNumbers('all', () => {
        this.searchNotifications();
      });
    });
  }

  onRoleClick() {
    this.getRequisitionNumbers('all', () => {
      this.searchNotifications();
    });
  }

  onRequisitionNumberClick() {
    this.searchNotifications();
  }

  _getRoles(searchReqText, successCallback?) {
    this.loadingRoles = true;
    this.fullRolesList = [];
    this.selectedRoles = [];
    if (searchReqText == '' || searchReqText === undefined) {
      searchReqText = 'all';
    } else {
      this.searchReqText = searchReqText;
    }
    let clientOrBuIds = this.selectedClients.map(clientOrBu => clientOrBu.id);
    this.jobService.getRoles(this.userId, this.companyId, this.searchReqText, { clientOrBuIds: clientOrBuIds }, (data) => {
      this._setRoles(data);
      this.loadingRoles = false;
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.loadingRoles = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _setRoles(roles) {
    roles.forEach((val) => {
      let roleObj: any = { name: val };
      if (!this._containsObject(roleObj, this.fullRolesList, 'name')) {
        if (val !== null) {
          roleObj.selectedDisplayName = this.displayOnMultiSelectPipe.transform(val);
        }
        this.fullRolesList.push(roleObj);
      }
      this.fullRolesListCopy = _.cloneDeep(this.fullRolesList);
    });
  }

  getRequisitionNumbers(searchReqText, successCallback?) {
    this.loadingRequisitionNumbers = true;
    this.fullReqNumList = [];
    this.selectedRequisitionNumbers = [];
    if (searchReqText == '' || searchReqText === undefined) {
      searchReqText = 'all';
    }
    this.searchReqText = searchReqText;
    let clientOrBuIds = this.selectedClients.map(clientOrBu => clientOrBu.id);
    let roleNames = this.selectedRoles.map(role => role.name);
    let reqNumberFilter = { clientOrBuIds: clientOrBuIds, roleNames: roleNames };
    this.jobService.searchByReqNum(this.userId, this.companyId, this.searchReqText, reqNumberFilter, (data) => {
      this._setRequisitionNumbers(data);
      if (searchReqText == 'all') {
        this.fullReqNumListCopy = _.cloneDeep(this.fullReqNumList);
      }
      this.loadingRequisitionNumbers = false;
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.loadingRequisitionNumbers = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _setRequisitionNumbers(requisitionNumbers) {
    let modifiedRequisitionNumbers = [];

    for (let i = 0; i < requisitionNumbers.length; i++) {
      let icon = requisitionNumbers[i].sharedRequisition ? '<i class="fas fa-share-alt"></i> ' : '<span class="pl-4"></span>';
      let obj: any = { name: requisitionNumbers[i].reqNumber, icon: icon };
      obj.selectedDisplayName = this.displayOnMultiSelectPipe.transform(obj.name);
      modifiedRequisitionNumbers.push(obj);
    }

    for (let i = 0; i < modifiedRequisitionNumbers.length; i++) {
      for (let j = 0; j < this.selectedRequisitionNumbers.length; j++) {
        if (modifiedRequisitionNumbers[i].name == this.selectedRequisitionNumbers[j].name) {
          modifiedRequisitionNumbers[i]['ticked'] = true;
          break;
        }
      }
    }
    this.fullReqNumList = _.cloneDeep(modifiedRequisitionNumbers);
  }

  selectRemoveAll(label, type) {
    this._setFiltersAndFetchJobs(label, type);
  }

  _setFiltersAndFetchJobs(label, type) {
    if (type === 'selectAll') {
      if (label === this.MESSAGECONSTANTS.LABLES.CLIENT || label === this.MESSAGECONSTANTS.LABLES.BU) {
        this.selectedClients = [...this.fullClientsList];
        this.onClientClick();
      } else if (label === this.MESSAGECONSTANTS.LABLES.USER_MANAGEMENT.ROLE) {
        this.selectedRoles = [...this.fullRolesList];
        this.onRoleClick();
      } else if (label === this.MESSAGECONSTANTS.LABLES.REQ_NUMBER) {
        this.selectedRequisitionNumbers = [...this.fullReqNumList];
        this.onRequisitionNumberClick();
      }
    } else {
      if (label === this.MESSAGECONSTANTS.LABLES.CLIENT || label === this.MESSAGECONSTANTS.LABLES.BU) {
        this.fullClientsList.forEach(clientOrBU => clientOrBU.ticked = false);
        this.selectedClients = [];
        this.onClientClick();
      } else if (label === this.MESSAGECONSTANTS.LABLES.USER_MANAGEMENT.ROLE) {
        this.fullRolesList.map(role => role.ticked = false);
        this.selectedRoles = [];
        this.onRoleClick();
      } else if (label === this.MESSAGECONSTANTS.LABLES.REQ_NUMBER) {
        this.fullReqNumList.map(num => num.ticked = false);
        this.selectedRequisitionNumbers = [];
        this.onRequisitionNumberClick();
      }
    }
  }

  getMultiSelectSummary(items: any[], bindLabel: string): string {
    if (!items || items.length === 0) { return ''; }
    const firstLabel = items[0][bindLabel];
    return items.length > 1 ? `${firstLabel} ... (${items.length})` : firstLabel;
  }

  _containsObject(obj, list, key) {
    for (var index in list) {
      var currentObject = list[index];
      for (var prop in currentObject) {
        if (prop === key && currentObject.hasOwnProperty(prop)
          && currentObject[prop] === obj[prop]) {
          return true;
        }
      }
    }
    return false;
  }

  getNotificationTypes() {
    this.loadingNotificationTypes = true;
    this.notificationsService.getNotificationTypes((data) => {
      this.alertTypes = data;
      this.loadingNotificationTypes = false;
    }, (error) => {
      this.loadingNotificationTypes = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  openModal(jobMatch, actionType, candidateId) {
    let actionLabel = actionType === 'jobProfile' ? 'Job Profile' : 'Candidate Job Comparison';
    const config = new ModalConfig();
    config.class = 'custom-modal-xl custom-candidate-job-match-modal';
    config.ignoreBackdropClick = true;
    config.keyboard = false;
    config.initialState = {
      actionType: actionType,
      actionLabel: actionLabel,
      notification: jobMatch,
      candidateId: candidateId
    };
    this.bsModalService.show(UserNotificationsActionsModalComponent, config as ModalOptions);
  }

  sendSelectedJobMatchOutreachEmail(jobMatches, candidateId, candidateType, clientOrBuId, successCallback) {
    const selectedJobMatches = jobMatches.filter(jobMatch => (jobMatch.jobMatchSelected && !jobMatch.outreachDisabled));
    if (selectedJobMatches.length === 0) {
      this.alertsAndNotificationsService.showAlert('No Selection', 'Please select at least One Job Match to Send Outreach to Candidate.', 'warning');
      return;
    } else {
      let outreachObject: any = {};
      let candidateIds = [
        {
          id: candidateId,
          candidateType: candidateType ? candidateType : 'OWN_CANDIDATES',
          source: 'CANDIDATE_CARD',
          jobIds: jobMatches.filter(jobMatch => (jobMatch.jobMatchSelected && !jobMatch.outreachDisabled)).map(jobMatch => jobMatch.jobId),
          jobMatchId: ''
        }
      ];
      outreachObject = {
        candidates: candidateIds,
        userId: this.userId,
        companyId: this.companyId,
        clientOrBuId: clientOrBuId ? clientOrBuId : jobMatches[0].clientOrBuId ? jobMatches[0].clientOrBuId : ''
      };

      this.candidateService.sendOutreachEmail(outreachObject, (data) => {
        this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
        if (successCallback) {
          successCallback();
        }
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }
  }

  ngOnDestroy() {
    if (this.notificationReceiveSubscription) {
      this.notificationReceiveSubscription.unsubscribe();
    }
  }
}

class SearchObject {
  companyId: any;
  page: any = '';
  size: any = 3;
  notifyOn: any = 'GLOBAL';
  alertType: any = '';
  startDateTime: any;
  endDateTime: any;
  firstName: any;
  lastName: any;
  jobTitle: any;
  clientName: any;
  requisitionNumber: any;
  onlyUnreadNotifications: any;
  clientOrBuIds: any;
  roleNames: any;
  reqNumbers: any;

  constructor(companyId, showFilters?) {
    this.companyId = companyId;
    this.page = '';
    this.size = 3;
    this.notifyOn = 'GLOBAL';
    if (showFilters) {
      this.alertType = '';
      this.startDateTime = null;
      this.endDateTime = null;
      this.firstName = null;
      this.lastName = null;
      this.jobTitle = null;
      this.clientName = null;
      this.requisitionNumber = null;
      this.onlyUnreadNotifications = false;
      this.clientOrBuIds = [];
      this.roleNames = [];
      this.reqNumbers = [];
    }
  }
}

class NotificationsContainer {
  authService: AuthService;
  context: any;
  showShortNotification: any;
  searchObject: any;
  showFilters: any;
  fullView: any;
  alertsAndNotificationsService: any;
  notificationsService: any;
  isStaffingCompany: any;
  outreachService: any;

  notifications: any[];
  newNotifications: any[];
  busy: boolean;
  isNotificationIconClicked: boolean;
  notificationsExistFlag: boolean;
  currentPromise: any;
  disableInfiniteScroll: boolean;
  isFilterOn: boolean;
  selectAll: boolean;
  originalNotificationCount: number;
  filteredNotificationCount: number;
  notificationCalledOnce: number;
  showShortMessagesFlag: boolean;

  constructor(authService: AuthService, context, showShortNotification, searchObject, showFilters, fullView, alertsAndNotificationsService, notificationsService, isStaffingCompany, outreachService) {
    this.authService = authService;
    this.context = context;
    this.showShortNotification = showShortNotification;
    this.searchObject = searchObject;
    this.showFilters = showFilters;
    this.fullView = fullView;
    this.alertsAndNotificationsService = alertsAndNotificationsService;
    this.notificationsService = notificationsService;
    this.isStaffingCompany = isStaffingCompany;
    this.outreachService = outreachService;

    this.$onInit();
  }

  $onInit() {
    this.notifications = [];
    this.newNotifications = [];
    this.busy = false;
    this.isNotificationIconClicked = false;
    this.notificationsExistFlag = true;
    this.searchObject = _.isUndefined(this.searchObject) ? new SearchObject(this.authService.userDetails.company.companyId, this.showFilters) : (_.isObject(this.searchObject) ? this.searchObject : JSON.parse(this.searchObject));
    this.currentPromise = null;
    this.disableInfiniteScroll = false;
    this.isFilterOn = false;
    this.selectAll = false;
    this.originalNotificationCount = 0;
    this.filteredNotificationCount = 0;
  }

  getNext(parentRef) {
    if (this.busy) {
      return;
    }
    this.busy = true;

    if (this.searchObject.page == '') {
      this.searchObject.page = 1;
    }
    this.searchObject.companyId = this.authService.userDetails.company.companyId;
    if (this.searchObject.page == 1 && this.notifications.length > 0) {
      this.searchObject.page = 2;
    }
    let tempSearchObject = _.cloneDeep(this.searchObject);
    this._setIsFilterOn();
    this.currentPromise = this.notificationsService.getNotifications(tempSearchObject, (data) => {
      if (data !== undefined && data != 'user cancellation' && data.notifications !== undefined) {
        const originalCount = data.notifications.length;
        if (data.notifications.length > 0) {
          if (this.context == 'global') {
            data.notifications = data.notifications.filter(notification => {
              if (notification.notifyOn) {
                return notification.notifyOn.indexOf('NO_GLOBAL') == -1;
              } else {
                return true;
              }
            });
          }
          parentRef.numberOfNewNotifications = data.unreadNotificationCount;
          parentRef.numberOfNewNotificationsChange.emit(parentRef.numberOfNewNotifications);
          data.notifications.forEach((val) => {
            val = this.massageMessageData(val);
            if (val.state == 'NEW' || val.state == 'VIEWED') {
              this.newNotifications.push(val);
            }
            if (val.operation == 'new') {
              let index = _.findIndex(this.notifications, {
                notificationId: this['notificationId']
              });
              if (index == -1) {
                this.notifications.push(val);
              }
            } else {
              this.notifications.push(val);
            }
          });
          if (this.searchObject.page > 1 && this.isNotificationIconClicked) {
            this.setNewNotificationsAsViewed();
          }
          if ((!this.fullView && !this.isNotificationIconClicked) || (originalCount < this.searchObject.size)) {
            this.disableInfiniteScroll = true;
          } else {
            this.disableInfiniteScroll = false;
            this.searchObject.page++;
          }
          this.originalNotificationCount = originalCount;
          this.filteredNotificationCount = data.notifications.length;
          this.notificationCalledOnce++;
        } else {
          this.disableInfiniteScroll = true;
        }
        if (this.notifications.length > 0) {
          this.notificationsExistFlag = true;
        } else {
          this.notificationsExistFlag = false;
        }
      }
      this.busy = false;
    }, (error) => {
      this.busy = false;
      this.disableInfiniteScroll = true;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      this.busy = false;
    });
  }

  _setIsFilterOn() {
    let filter = this.searchObject;
    if (
      (filter.clientOrBuIds !== undefined && filter.clientOrBuIds.length > 0)
      || (filter.reqNumbers !== undefined && filter.reqNumbers.length > 0)
      || (filter.roleNames !== undefined && filter.roleNames.length > 0)
      || (filter.alertType !== undefined && filter.alertType.length > 0)
      || (filter.firstName !== undefined && filter.firstName.length > 0)
      || (filter.lastName !== undefined && filter.lastName.length > 0)) {
      this.isFilterOn = true;
    } else {
      this.isFilterOn = false;
    }
  }

  massageMessageData(message) {
    if (_.isNull(message.state)) {
      message.state = 'NEW';
    }
    if (message.candidateDtoMap) {
      let date = moment(message.createdDate).format('MMM DD, YYYY hh:mm A');
      message.taggedText = `${message.taggedText.split('at <4dot5>')[0]} at <4dot5>'${date}'</4dot5>`;
    }
    message.createdDate = new Date(message.createdDate);
    message.selectedFlag = this.selectAll;
    if (!_.isNull(message.taggedText)) {
      message.highlightedHTMLText = this._getHighlightedNotificationHTML(message.taggedText);
    } else {
      message.highlightedHTMLText = message.text;
    }
    message.showShortMessageFlag = this.showShortMessagesFlag;
    message.showRedirect = false;
    message.showCandidateScreenRedirect = false;
    if (!_.isNull(message.redirect) && message.redirect.screenName == 'CANDIDATE_WORKFLOW' && !_.isNull(message.redirect.candidateName)) {
      message.showRedirect = true;
    }
    if ((!_.isUndefined(message.jbiTransactionId) && !_.isNull(message.jbiTransactionId)) || (!_.isUndefined(message.assessmentType) && !_.isNull(message.assessmentType))) {
      message.showRedirect = true;
    }
    if (!_.isNull(message.candidateScreenRedirect) && message.candidateScreenRedirect !== undefined && this.context == 'global') {
      message.showCandidateScreenRedirect = true;
    }
    if (!message.candidateScreenRedirect && (this.context == 'global' && (message.eventType && message.eventType === 'COMPANY_RE_RUN_SCORING'))) {
      message.showCandidateScreenRedirect = true;
    }
    if ((message.candidateDtoMap || message.documentDtoMap) && (message.eventType && !message.eventType.includes('RE_RUN_SCORING'))) {
      message.showRedirect = true;
    }
    if (message.requisitionScreenRedirect) {
      message.showRedirect = true;
    }

    if (message.reasons && message.reasons.length > 0 && message.eventType.includes('CANDIDATE_NO_LONGER_MATCHES')) {
      message.reasons = message.reasons.map(reason => {
        const matches = reason.match(/<4dot5>(.*?)<\/4dot5>/g);

        if (matches && matches.length > 0) {
          for (let i = 0; i < matches.length; i++) {
            const fullTag = matches[i];
            const value = fullTag.replace(/<\/?4dot5>/g, '');

            if (moment(value, moment.ISO_8601, true).isValid()) {
              const formatted = moment(value).format('MMM D, YYYY h:mm A');
              reason = reason.replace(fullTag, '<4dot5>' + formatted + '</4dot5>');
            }
          }
        }

        return this._getHighlightedNotificationHTML(reason);
      });

      message.showNoLongerMatchResults = true;
    }

    const outreachEventTypes = [
      'OUTREACH_SAVED',
      'OUTREACH_COMPLETED',
      'OUTREACH_SENT',
      'OUTREACH_NO_RESPONSE_EXPIRED',
      'OUTREACH_RESPONSE_EXPIRED',
      'OUTREACH_NOT_COMPLETED_EXPIRED',
      'OUTREACH_COMPLETION_EXPIRED',
      'OUTREACH_RESPONSE_REMINDER',
      'OUTREACH_COMPLETION_REMINDER'
    ];

    if (outreachEventTypes.includes(message.eventType) && message.candidateOutreachJobMatchesInfo) {
      if (typeof message.candidateOutreachJobMatchesInfo === 'string') {
        message.candidateOutreachJobMatchesInfo = JSON.parse(message.candidateOutreachJobMatchesInfo);
      }
      if (message.candidateOutreachJobMatchesInfo.jobMatches && message.candidateOutreachJobMatchesInfo.jobMatches.length > 0) {
        message.showOutreachNoResponseIcon = true;
        this.setOutreachJobMatchDetails(message);
      }
    }

    return message;
  }

  _getHighlightedNotificationHTML(text) {
    let newText = text.replace(/<4dot5>/g, '<span class=\'emerald\'>');
    return newText ? newText.replace(/<\/4dot5>/g, '</span>') : '';
  }

  setNewNotificationsAsViewed() {
    if (this.showShortNotification) {
      this._setNotificationsAsShort();
    }
    this.isNotificationIconClicked = true;
    if (this.newNotifications.length > 0) {
      let stateObject = {
        notificationIds: [],
        state: 'VIEWED'
      };
      this.newNotifications.forEach((val) => {
        stateObject.notificationIds.push(val.notificationId);
      });
      this.notificationsService.setNotificationsState(stateObject, (data) => {
        // do nothing. notification state change will be received as a push update.
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }
  }

  _setNotificationsAsShort() {
    this.notifications.forEach((notification) => {
      notification.showShortMessageFlag = true;
    });
  }

  setOutreachJobMatchDetails(message) {
    message.candidateOutreachJobMatchesInfo.jobMatches.forEach(jobMatch => {
      this.outreachService.setCompanyLocationLabel(jobMatch, this.isStaffingCompany);
      jobMatch.missingOrNonMatched = this.outreachService.setMissedOrMatchedInfo(jobMatch.missingOrNonMatchedInfo, jobMatch.workLocations);
      jobMatch.formattedOutreachStatus = this.outreachService.formatOutreachStatus(jobMatch.outreachStatus);
      jobMatch.jobDetails = this.outreachService.setJobDetailsLabel(jobMatch, this['jobTypeList'], this['salaryDurationOptions']);
      jobMatch.daysSinceOutreach = this.outreachService.setDaysSinceOutreach(jobMatch);
      jobMatch.candidateMatch = this.outreachService.setCandidateMatchingLabel(jobMatch);
      jobMatch.outreachExpiryDate = this.outreachService.setOureachExpiryDate(jobMatch, message);
      jobMatch.isScoreMatched = (jobMatch.score && jobMatch.thresholdScore) ? jobMatch.score >= jobMatch.thresholdScore : false;
    });
    message.isOutreachExpiryDataExists = message.eventType.includes('EXPIRY') || message.candidateOutreachJobMatchesInfo.jobMatches.some(jm => jm.outreachExpiryDate);
  }
}
